import { proxy, useSnapshot } from "valtio";

interface IPreprocessProgressState {
	progress:
		| {
				progressCount?: number;
				total: number;
		  }
		| undefined;
}

export const preprocessProgressState = proxy<IPreprocessProgressState>({
	progress: undefined,
});

function setPhotoPreprocessProgress(
	value:
		| {
				progressCount?: number;
				total: number;
		  }
		| undefined,
) {
	preprocessProgressState.progress = value;
}

export const usePhotoPreprocessProgress = () =>
	[useSnapshot(preprocessProgressState).progress, setPhotoPreprocessProgress] as const;
